import Highcharts from 'highcharts';

import { InsightsChartSpec } from 'services/streamInsightsQuery';

import { baseInsightsOptions, valueAxis } from './shared';

// bar | column | line | area — the original category-axis charts. One series per
// metric (or per breakdown value for a matrix), plotted against shared
// categories that are either breakdown members or trend dates.
const buildCartesianOptions = (
  spec: InsightsChartSpec,
): Highcharts.Options => ({
  ...baseInsightsOptions({
    spec,
    chartType: spec.chartType,
    usePointName: false,
    showLegend: spec.series.length > 1,
  }),
  series: spec.series.map((s) => ({
    type: spec.chartType,
    name: s.name,
    data: s.data,
  })) as Highcharts.SeriesOptionsType[],
  xAxis: {
    categories: spec.categories,
    // See valueAxis in ./shared — axis titles repeat the chart title here.
    title: { text: undefined },
  },
  yAxis: valueAxis(spec),
});

export default buildCartesianOptions;
